import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import styled, { css } from 'styled-components';

const NavbarContainer = styled.nav`
  background: linear-gradient(to right, #536976, #292e49);
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 999;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.scrolled &&
    css`
      background-color: #000;
    `}
`;

const NavbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  padding: 0 24px;
`;

const NavbarLogo = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
`;

const NavbarIcon = styled.div`
  margin-right: 0.5rem;
`;

const LogoImage = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 0.5rem;
`;

const MenuIcon = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 80vh;
    position: absolute;
    top: 60px;
    left: ${({ click }) => (click ? 0 : '-110%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: linear-gradient(to right, #536976, #292e49);
  }
`;

const NavItem = styled.li`
  height: 80px;
  border-bottom: 2px solid transparent;
  margin-right : 6rem;

  &:hover {
    border-bottom: 2px solid #fff;
  }

  @media screen and (max-width: 960px) {
    width: 100%;

    &:hover {
      border: none;
    }
  }
`;

const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;

  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;

    &:hover {
      color: #4b59f7;
      transition: all 0.3s ease;
    }
  }
`;

function Navbar() {
  const [click, setClick] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setClick(false); // Added to close menu when resizing
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    showButton();
    window.addEventListener('resize', showButton);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', showButton);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <NavbarContainer scrolled={scrolled}>
        <NavbarWrapper>
          <NavbarLogo to='/' onClick={closeMobileMenu}>
            <NavbarIcon />
            <LogoImage src='/img/razqa.png' alt='Logo' />
          </NavbarLogo>
          <MenuIcon onClick={handleClick}>
            {click ? <FaTimes /> : <FaBars />}
          </MenuIcon>
          <NavMenu click={click}>
            <NavItem>
              <NavLink to='/' onClick={closeMobileMenu}>
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to='/about' onClick={closeMobileMenu}>
                About
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to='/contact' onClick={closeMobileMenu}>
                Contact
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to='/products' onClick={closeMobileMenu}>
                Products
              </NavLink>
            </NavItem>
          </NavMenu>
        </NavbarWrapper>
      </NavbarContainer>
    </div>
  );
}

export default Navbar;
